import { createAsyncThunk } from '@reduxjs/toolkit';
import { getToken, removeToken, removeRefreshToken, removeUserData, setToken, setRefreshToken } from '../../utils/HelperFunctions';
import api from '../../services/api';
import { useNavigate } from 'react-router-dom';

export const fetchUserData = createAsyncThunk('auth/fetchUserData', async (_, { rejectWithValue }) => {
  try {
    const accessToken = getToken();
    console.log('redux accesstoken: ' + accessToken);
    api.defaults.headers.Authorization = `Bearer ${accessToken}`;
    const response = await api.post('/auth/validatetoken');
    return { ...response.data, accessToken };
  } catch (e) {
    removeToken();
    removeRefreshToken();
    return rejectWithValue('');
  }
});

type LoginPayload = { username: string; password: string };

export const login = createAsyncThunk('auth/login', async (payload: LoginPayload) => {
  const response = await api.post('/users/login', payload);
  setToken(response.data.token);
  if (response.data.refreshToken) {
    setRefreshToken(response.data.refreshToken);
  }
  localStorage.setItem('SSOLogin', 'false');
  api.defaults.headers.Authorization = `Bearer ${response.data.token}`;

  return response.data;
});

export const signOut = createAsyncThunk('auth/signOut', async () => {
  removeToken();
  removeRefreshToken();
  removeUserData();
  localStorage.setItem('SSOLogin', 'false');
});
